import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  header: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.colors.neutral[100]}`,
    fontSize: 13,
    mb: 2.5,
    '> *': {
      textAlign: 'center',
      lineHeight: '42px',
      color: theme.colors.neutral[500],
    },
  }),

  kpiLabel: (theme: Theme) => ({
    bgcolor: theme.colors.neutral[200],
    color: theme.colors.neutral[600],
    borderRadius: '8px',
    lineHeight: '20px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    padding: 1.25,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),

  kpiBar: (widthPercentage: number) => ({
    width: `${widthPercentage}%`,
    alignItems: 'center',
  }),

  arrow: {
    flexGrow: 1,
    position: 'relative',
  },

  dottedLine: (theme: Theme) => ({
    borderTop: `1px dashed ${theme.colors.neutral[400]}`,
    transform: 'translateY(50%)',
    mr: 0.5,
  }),

  arrowHead: (theme: Theme) => ({
    width: 0,
    height: 0,
    position: 'absolute',
    right: 0,
    transform: 'translateY(-50%)',
    borderTop: '3px solid transparent',
    borderBottom: '3px solid transparent',
    borderLeft: `6px solid ${theme.colors.neutral[400]}`,
  }),

  bubble: (index: number) => (theme: Theme) => ({
    py: 1.25,
    ml: 1.75,
    mr: 0.5,
    bgcolor: theme.colors.secondary[500],
    borderRadius: '50%',
    width: '40px',
    lineHeight: '20px',
    flexShrink: 0,
    textAlign: 'center',
    boxShadow:
      index === 0
        ? `0px 0px 0px 4px ${alpha(theme.colors.secondary[500], 0.2)}`
        : `0px 0px 0px 4px ${alpha(theme.colors.secondary[500], 0.1)}`,
    fontWeight: 700,
    fontSize: '10px',
  }),

  extraHighlighted: (theme: Theme) => ({
    bgcolor: theme.colors.secondary[500],
    color: theme.colors.secondary[800],
  }),

  highlighted: (theme: Theme) => ({
    bgcolor: theme.colors.secondary[200],
    color: theme.colors.secondary[800],
  }),
};
